module.exports = __webpack_public_path__ + "static/media/ws-home-delivery-blue.ff16e8a8.svg";